<mat-card class="export-card">
  <app-card-header
    title="Exportar eventos de alarmas"
    [subtitle]="
      alarma
        ? 'Exportará sólo los eventos de la alarma seleccionada'
        : cliente
          ? 'Exportará todos los eventos de alarmas del cliente'
          : 'Seleccioná una alarma o un cliente para comenzar'
    "
    icono="table_view"
    [draggable]="false"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <section class="inputs-group">
      <app-info-banner
        icon="doorbell"
        title="Exportación de eventos de alarmas"
        message="Exporta el <b>historial de eventos</b> de alarmas domiciliarias en el período seleccionado.<br><b>Requerido:</b> alarma o cliente + rango de fechas.<br><b>Opcional:</b> seleccionar alarma limita a esa alarma; seleccionar cliente exporta todas sus alarmas. Con cliente podés incluir hijos y alarmas sin eventos en el período."
        [closable]="false"
        margin="0"
        style="width: 100%"
      ></app-info-banner>
    </section>

    <!-- Qué exportar -->
    <app-content-card title="Alcance" icon="filter_alt">
      <section class="inputs-group">
        <!-- Alarma (siempre visible, filtra por cliente si hay uno) -->
        <div class="campo">
          <ng-select
            [(ngModel)]="alarma"
            [items]="alarmasFiltradas"
            [placeholder]="cargandoAlarmas ? 'Cargando alarmas...' : 'Alarma'"
            notFoundText="No se encontraron alarmas"
            [loading]="cargandoAlarmas"
            [clearable]="true"
            [searchable]="true"
            [searchFn]="alarmaSearchFn"
            [virtualScroll]="true"
            [dropdownPosition]="'auto'"
            appendTo="body"
          >
            <ng-template ng-option-tmp let-item="item">
              <span>{{ alarmaLabel(item) }}</span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span>{{ alarmaLabel(item) }}</span>
            </ng-template>
          </ng-select>
          <small class="ayuda">
            Buscá por número o nombre. Requerida si no hay cliente.
          </small>
        </div>

        <!-- Cliente (opcional, filtra la lista de alarmas) -->
        <div class="campo">
          <app-cliente-selector
            [filterModules]="['moduloAlarmasDomiciliarias']"
            placeholder="Cliente"
            [clearable]="true"
            (clienteChange)="onClienteChange($event)"
          ></app-cliente-selector>
          <small class="ayuda">
            Filtra las alarmas. Requerido si no hay alarma.
          </small>
        </div>
      </section>

      <!-- Incluir test: sólo cuando hay alarma seleccionada -->
      @if (alarma) {
        <section class="inputs-group">
          <mat-checkbox color="primary" [(ngModel)]="incluirTest">
            Incluir eventos de test
          </mat-checkbox>
        </section>
      }

      <!-- Incluir hijos / sin eventos: sólo con cliente y sin alarma -->
      @if (cliente && !alarma) {
        <section class="inputs-group">
          <div class="campo">
            <mat-checkbox
              color="primary"
              [(ngModel)]="incluirHijos"
              [disabled]="hijosDeshabilitado"
            >
              Incluir clientes hijos
            </mat-checkbox>
            @if (hijosDeshabilitado) {
              <small class="ayuda error">
                El cliente tiene más de 300 hijos con alarmas ({{
                  totalAlarmasConHijos
                }}). No se puede incluir hijos.
              </small>
            }
          </div>
          <div class="campo">
            <mat-checkbox color="primary" [(ngModel)]="incluirSinEventos">
              Incluir alarmas sin eventos en el período
            </mat-checkbox>
          </div>
        </section>
      }
    </app-content-card>

    <!-- Rango de fechas -->
    <app-content-card title="Período" icon="date_range">
      <section class="inputs-group">
        <div class="campo">
          <app-date-picker
            mode="datetimerange"
            label="Rango de fechas"
            [(ngModel)]="rango"
          ></app-date-picker>
          <small class="ayuda" [class.error]="rangoExcedeMes">
            @if (rangoExcedeMes) {
              El rango no puede superar 31 días.
            } @else {
              Requerido, máximo 1 mes.
            }
          </small>
        </div>
      </section>
      <section class="inputs-group">
        <div class="presets">
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('esteMes')"
          >
            Este mes
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('mesPasado')"
          >
            Mes pasado
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('1semana')"
          >
            1 semana
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('48h')"
          >
            48 horas
          </button>
          <button
            irxBoton="secundario"
            type="button"
            (click)="setRangoPreset('24h')"
          >
            24 horas
          </button>
        </div>
      </section>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <span class="pie-espacio"></span>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="!canExport"
      (click)="exportar()"
    >
      <mat-icon>download</mat-icon>
      {{ exportLabel }}
    </button>
  </mat-card-actions>
</mat-card>
